import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Accordion } from '@holmescorp/base-widgets';
import { pathmap, keymap, userstate, createNlsMiddleware } from 'lcc-state';
import { Keys } from '@holmescorp/common';
import { publish } from '@holmescorp/pub-sub';
import css from '../../css/topics.m.css';
const factory = create({
    theme,
    userstate,
    nls: createNlsMiddleware('ditabook')
}).properties();
export const GroupNav = factory(({ properties, middleware: { theme, userstate, nls } }) => {
    const { currentTopicGroupKey = '', topicset } = properties();
    const { get, path } = userstate;
    const { messages: { topic_group_section_label = 'Lesson' } } = nls();
    const themeCss = theme.classes(css);
    const status = get(path('status'));
    const topicGroups = topicset.children?.filter((tg) => !('shortdesc' in tg)) || [];
    const generateLesson = (topic, topicgroupKey) => {
        const topicId = topic.topicref.attributes?.rel || '';
        const topicKeyRef = topic.topicref.attributes?.id || '';
        const topicStatus = status[topicId].data;
        return v('div', {
            classes: [themeCss.accordionContentRow],
            key: `${topicgroupKey}-${topicId}`,
            xqa: `topic ${topicId}`,
            role: 'button',
            tabIndex: 0,
            onclick: (event) => {
                event.stopPropagation();
                if (currentTopicGroupKey === topicgroupKey) {
                    publish('scroll-to-topic', topicKeyRef);
                }
                else {
                    const { path } = keymap.get(topicgroupKey);
                    const { view } = pathmap.get(path);
                    view();
                }
            },
            onkeydown: (event) => {
                switch (event.key) {
                    case Keys.Enter:
                    case Keys.Space:
                    case Keys.Spacebar:
                        if (currentTopicGroupKey === topicgroupKey) {
                            publish('scroll-to-topic', topicKeyRef);
                        }
                        else {
                            const { path } = keymap.get(topicgroupKey);
                            const { view } = pathmap.get(path);
                            view();
                        }
                }
            }
        }, [
            v('div', {
                classes: [themeCss.lessonTitleRow]
            }, [
                topicStatus.complete > 0
                    ? v('img', {
                        src: `${window.hcstatic.portal_cdn}/js/images/icons/circle-check-complete.svg`,
                        alt: `Reading for ${topic.topicref.attributes?.title} is complete`
                    })
                    : null,
                v('img', {
                    src: `${window.hcstatic.portal_cdn}/js/images/icons/book-open.svg`,
                    alt: `Reading icon for ${topic.topicref.attributes?.title}`
                }),
                v('span', {}, [topic.topicref.attributes?.title])
            ]),
            v('span', { classes: [themeCss.readingTime] }, [`${topic.topicref.attributes?.readtime} mins`])
        ]);
    };
    const accordionContent = topicGroups.map((tg, index) => {
        return {
            key: `topicgroup-${tg.topicgroup.attributes?.key}`,
            content: tg.topicgroup.children
                ?.filter((t) => !('shortdesc' in t))
                .map((topic) => generateLesson(topic, tg.topicgroup.attributes?.key || '')),
            title: [
                v('div', {
                    xqa: `topicgroup ${tg.topicgroup.attributes?.key}`,
                    classes: [themeCss.accordionTitleContainer]
                }, [
                    v('p', { classes: [themeCss.accordionTitle] }, [
                        v('span', { classes: [themeCss.accordionGroupNumber] }, [
                            `${topic_group_section_label} ${index + 1}`
                        ]),
                        v('span', { classes: [themeCss.accordionGroupTitle] }, [
                            `${tg.topicgroup.attributes?.title}`
                        ])
                    ])
                ])
            ]
        };
    }) || [];
    return v('div', { classes: [themeCss.accordion] }, [
        w(Accordion, {
            exclusive: true,
            headingLevel: 1,
            openKeys: [`topicgroup-${currentTopicGroupKey}`]
        }, accordionContent)
    ]);
});
export default GroupNav;
